jQuery(document).ready(function () {
  let attempts = 0;
  const maxAttempts = 20;
  const intervalTime = 300;

  function overwriteWpformsScrollFunction() {
    if (window.wpforms && typeof window.wpforms.animateScrollTop === 'function') {
      const original = window.wpforms.animateScrollTop.bind(window.wpforms);

      window.wpforms.animateScrollTop = function (position, duration, complete) {
        let offset = 0;
        jQuery.each(['#wpadminbar', '.mad-navbar__section'], function (_, selector) {
          const el = jQuery(selector);
          if (el.length) {
            offset += el.outerHeight();
          }
        });

        const newPosition = Math.max(position - offset, 0);
        return original(newPosition, duration, complete);
      };

    } else if (attempts < maxAttempts) {
      attempts++;
      setTimeout(overwriteWpformsScrollFunction, intervalTime);
    }
  }
  
  overwriteWpformsScrollFunction();
});
